import { useLocation, Link } from "react-router-dom";
import { Ticket } from "lucide-react";
import WhatsAppIcon from "@/components/WhatsAppIcon";
import { TID, WHATSAPP_URL } from "@/constants/testIds";

/**
 * Mobile sticky bar (bottom):
 * • Primary — "Register for Launch" (→ /event, boarding pass + spin wheel)
 * • WhatsApp icon button (official WhatsApp glyph)
 * Hidden on the EOI landing.
 */
export default function StickyMobileCTA() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/eoi")) return null;

  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 z-40">
      <div
        className="px-4 py-3 flex gap-2 backdrop-blur-md border-t"
        style={{ background: "rgba(11,74,61,0.94)", borderColor: "rgba(166,206,57,0.3)" }}
      >
        <Link
          to="/event"
          data-testid={TID.stickyStrategy}
          className="btn-primary flex-1 text-sm py-3"
        >
          <Ticket size={16} /> Register for Launch
        </Link>
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noreferrer"
          data-testid={TID.stickyWhatsapp}
          className="flex-none inline-flex items-center justify-center gap-1.5 text-sm py-3 px-4 rounded-full text-[#F4F4EF] hover:text-[#25D366] transition-colors border"
          style={{ borderColor: "rgba(37,211,102,0.55)", background: "rgba(37,211,102,0.14)" }}
          aria-label="WhatsApp"
        >
          <WhatsAppIcon size={18} className="text-[#25D366]" />
        </a>
      </div>
    </div>
  );
}
